module.exports = __webpack_public_path__ + "img/functional2-img3.00e5cdda.png";